import React from "react";
import { useNavigate } from "react-router-dom";

import { useThreads } from "@/services/hooks";

import ThreadCard from "@/components/ThreadCard";
import { Divider, Box, Typography, IconButton } from "@mui/material";
import { ArrowForwardIos } from "@mui/icons-material";

export default function ThreadsContainer({ artistKey }) {
  const navigate = useNavigate();

  const { data: artistContent } = useThreads(artistKey);

  return (
    <>
      {artistContent?.length > 0 && (
        <Box
          id="threads"
          sx={{
            pb: 8,
            pt: 2,
            px: 2,
          }}
        >
          <Box
            style={{ display: "flex", justifyContent: "space-between" }}
            sx={{ mt: 4 }}
          >
            <Typography variant="h6" sx={{ fontWeight: 800 }}>
              Community
            </Typography>
            <IconButton onClick={() => navigate(`/${artistKey}/threads`)}>
              <ArrowForwardIos />
            </IconButton>
          </Box>

          <Box sx={{ mt: 4 }}>
            <Box>
              {artistContent
                ?.sort((a, b) => b.updated - a.updated)
                .slice(0, 3)
                .map((thread, index) => (
                  <Box key={index}>
                    <ThreadCard key={index} content={thread} />
                    <Divider />
                  </Box>
                ))}
            </Box>

            <Box
              sx={{ mt: 4 }}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
              onClick={() => navigate(`/${artistKey}/threads`)}
            >
              <Typography variant="body1" color="darkgray">
                {`View all topics or start a new one`}
              </Typography>
              <ArrowForwardIos
                style={{ fontSize: "15px", color: "darkgray" }}
                sx={{ ml: 2 }}
              />
            </Box>
          </Box>
        </Box>
      )}
    </>
  );
}
